import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReorderEvent } from '@common/ui/frontend-shared/orderlist';
import { LocalMessageHandlerService, ModelColumnService, takeWhileAlive } from '@core/frontend-shared';
import { BehaviorSubject, filter, take } from 'rxjs';
import { CrudManagerService } from '../crud-manager';
import { CrudListItemComponent } from './crud-list-item.component';
import { AsyncPipe } from '@angular/common';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { NgLetDirective } from '@core/frontend-shared/utils/directives';
import * as i0 from "@angular/core";
import * as i1 from "../crud-manager";
import * as i2 from "@angular/router";
import * as i3 from "@core/frontend-shared";
import * as i4 from "@common/ui/frontend-shared/orderlist";
const _c0 = a0 => ({
  name: a0,
  icon: null
});
function CrudListComponent_ng_template_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const loadingState_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("item", item_r3)("loadingState", loadingState_r4)("itemInfo", i0.ɵɵpureFunction1(4, _c0, item_r3.name))("layout", ctx_r1.itemLayout);
  }
}
function CrudListComponent_ng_template_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function CrudListComponent_ng_template_0_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigate(["new"]));
    });
    i0.ɵɵelementEnd();
  }
}
function CrudListComponent_ng_template_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function CrudListComponent_ng_template_0_Conditional_5_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deleteSelected($event));
    });
    i0.ɵɵelementEnd();
  }
}
function CrudListComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-orderList", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtwoWayListener("selectionChange", function CrudListComponent_ng_template_0_Template_ui_orderList_selectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedItems, $event) || (ctx_r1.selectedItems = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onSelectionChange", function CrudListComponent_ng_template_0_Template_ui_orderList_onSelectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.updateSelection($event));
    })("onReorderItems", function CrudListComponent_ng_template_0_Template_ui_orderList_onReorderItems_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onReorderItems($event));
    });
    i0.ɵɵtemplate(2, CrudListComponent_ng_template_0_ng_template_2_Template, 1, 6, "ng-template", 2);
    i0.ɵɵelementStart(3, "ui-footer");
    i0.ɵɵconditionalCreate(4, CrudListComponent_ng_template_0_Conditional_4_Template, 1, 0, "button", 3);
    i0.ɵɵconditionalCreate(5, CrudListComponent_ng_template_0_Conditional_5_Template, 1, 0, "button", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const loadingState_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", i0.ɵɵpipeBind1(1, 9, ctx_r1.items$))("header", ctx_r1.header || ctx_r1.crudManager.getItemText("items"));
    i0.ɵɵtwoWayProperty("selection", ctx_r1.selectedItems);
    i0.ɵɵproperty("metaKeySelection", true)("dragdrop", ctx_r1.crudManager.config.list.reordering)("loading", loadingState_r4.allLoading)("trackBy", ctx_r1.config.list.trackBy);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.crudManager.enableCreate ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.crudManager.enableDelete && ctx_r1.selectedItems.length ? 5 : -1);
  }
}
export let CrudListComponent = /*#__PURE__*/(() => {
  class CrudListComponent {
    set selection(val) {
      this.selectedItems = val && val != null ? [val] : [];
    }
    get config() {
      return this.crudManager.config;
    }
    get service() {
      return this.crudManager.service;
    }
    get filterFormService() {
      return this.listController.getFilterFormService();
    }
    get state() {
      throw new Error('not implemented currrently');
    }
    constructor(crudManager, route, router, cd, modelColumnService) {
      this.crudManager = crudManager;
      this.route = route;
      this.router = router;
      this.cd = cd;
      this.modelColumnService = modelColumnService;
      this.destroyRef = inject(DestroyRef);
      this.itemLayout = 'default';
      this.selectedItems = [];
      this.items$ = new BehaviorSubject(null);
      this.listController = crudManager.getListController();
      const obs = this.listController.getSubscriptions();
      this.loadingState$ = obs.loadingState$.pipe(takeWhileAlive(this.destroyRef));
      this.isLoadingDependencies$ = obs.isLoadingDependencies$.pipe(takeWhileAlive(this.destroyRef));
      this.listController.createItemsObservable().pipe(takeWhileAlive(this.destroyRef)).subscribe(items => {
        this.items$.next(items);
      });
      this.setupSelectionUpdateByRouteChanges();
    }
    setupSelectionUpdateByRouteChanges() {
      // handle item deselection when editor is closed or not in a item-specific mode
      this.crudManager.crudRouteState$.pipe(takeWhileAlive(this.destroyRef)).subscribe(changeEvent => {
        if (changeEvent.type === 'list' || typeof changeEvent.id !== 'number') {
          this.selectedItems = [];
          this.cd.markForCheck();
        } else {
          // in some situations navigation to item is done outside of CrudListComponent.
          // e.g. when a new item was created and a redirect to edit view is executed.
          // so if the routeState contains usable information and nothing is selected, this will set selection programmatically.
          const items = this.items$.getValue();
          if (items) {
            const itemToSelect = items.find(item => item.id === changeEvent.id);
            if (!this.selectedItems.length && itemToSelect) {
              this.selectedItems = [itemToSelect];
              this.cd.markForCheck();
            }
          }
        }
      });
      // restore correct selection on window navigation
      // TODO: note this works only on page reload, not for history navigation state!
      this.crudManager.modeAndItem$.pipe(filter(data => data.mode !== null), take(1), takeWhileAlive(this.destroyRef)).subscribe(data => {
        if (data.mode === 'edit') {
          this.selectedItems = [data.item];
          this.cd.markForCheck();
        }
      });
    }
    navigate(commands) {
      this.crudManager.navigate(commands);
    }
    updateSelection(event) {
      if (event.value[0]) {
        this.navigate([event.value[0].id]);
      } else {
        this.navigate(['./']);
      }
    }
    deleteSelected(event) {
      if (event) event.stopPropagation();
      if (this.selectedItems.length > 1) throw new Error('deleting multiple items at once is not supported');
      this.crudManager.executeItemAction(this.selectedItems[0], 'delete').subscribe(deletionExecuted => {
        if (deletionExecuted) this.crudManager.navigateTo('list');
      });
    }
    onReorderItems(event) {
      this.service.crud.updateOrdering(event.result).subscribe();
    }
    static {
      this.ɵfac = function CrudListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudListComponent)(i0.ɵɵdirectiveInject(i1.CrudManagerService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.ModelColumnService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudListComponent,
        selectors: [["crud-item-list"]],
        inputs: {
          header: "header",
          itemLayout: "itemLayout",
          selection: "selection"
        },
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        decls: 2,
        vars: 3,
        consts: [[3, "ngLet"], ["selectionLimit", "1", "dragHandlePosition", "left", 3, "selectionChange", "onSelectionChange", "onReorderItems", "value", "header", "selection", "metaKeySelection", "dragdrop", "loading", "trackBy"], ["uiTemplate", "item"], ["uiButton", "", "label", "neu", "icon", "plus"], ["uiButton", "", "label", "l\u00F6schen", "icon", "trash", "title", "l\u00F6schen", 1, "ui-button-danger"], ["crud-list-item", "", 3, "item", "loadingState", "itemInfo", "layout"], ["uiButton", "", "label", "neu", "icon", "plus", 3, "click"], ["uiButton", "", "label", "l\u00F6schen", "icon", "trash", "title", "l\u00F6schen", 1, "ui-button-danger", 3, "click"]],
        template: function CrudListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CrudListComponent_ng_template_0_Template, 6, 11, "ng-template", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngLet", i0.ɵɵpipeBind1(1, 1, ctx.loadingState$));
          }
        },
        dependencies: [NgLetDirective, i4.UiOrderListComponent, i4.UiFooterComponent, i4.UiTemplateDirective, CrudListItemComponent, UiButtonComponent, AsyncPipe],
        styles: ["[_nghost-%COMP%]{padding:0;display:flex;flex-direction:column;height:100%}\n\n/*# sourceMappingURL=crud-list.component.ts-angular-inline--81.css.map*/", "[_nghost-%COMP%]    >ui-orderList ui-footer{display:flex}\n\n/*# sourceMappingURL=crud-list.component.ts-angular-inline--82.css.map*/", "[_nghost-%COMP%]    >ui-orderList ui-footer button{flex:1}\n\n/*# sourceMappingURL=crud-list.component.ts-angular-inline--83.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return CrudListComponent;
})();